import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';
import { ColumnTypeModule } from '@y42/column-type';
import { ListViewModule } from '@y42/core/list-view';
import { MonacoEditorModule } from '@y42/monaco-editor';
import { AngularSplitModule } from 'angular-split';
import { MarkdownModule } from 'ngx-markdown';
import { TargetColumnModule } from '../target-column';
import { DocumentationModalComponent } from './components/documentation-modal/documentation-modal.component';
import { FunctionDetailsRendererComponent } from './components/function-list-view/components/function-details-renderer/function-details-renderer.component';
import { FunctionTagRendererComponent } from './components/function-list-view/components/function-tag-renderer/function-tag-renderer.component';
import { FunctionListViewComponent } from './components/function-list-view/function-list-view.component';
import { FunctionEditorComponent } from './function-editor.component';
import { ColumnTypeToTsTypePipe } from './pipes/column-type-to-ts-type.pipe';
import { TsTypeToColumnTypePipe } from './pipes/ts-type-to-column-type.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularSplitModule,
    MatButtonModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MonacoEditorModule,
    FontAwesomeModule,
    MtxPopoverModule,
    ListViewModule,
    ColumnTypeModule,
    MarkdownModule.forChild(),
    TargetColumnModule,
  ],
  declarations: [
    FunctionEditorComponent,
    DocumentationModalComponent,
    FunctionListViewComponent,
    FunctionDetailsRendererComponent,
    FunctionTagRendererComponent,
    ColumnTypeToTsTypePipe,
    TsTypeToColumnTypePipe,
  ],
  exports: [FunctionEditorComponent, FunctionListViewComponent],
})
export class FunctionEditorModule {}
